import { createFileRoute } from '@tanstack/react-router';
import { AppLayout } from '@/components/app-layout';
import { AuthCheck } from '@/components/auth-check.component';
import { FeatureGate } from '@/components/feature-gate.component';
import { Head } from '@/components/head.component';
import { Feature } from '@/constants/features';
import { AgentsGate } from '@/containers/agents/agents-gate.component';
import { ApprovalsInbox } from '@/containers/agents/approvals/approvals-inbox.component';

// W3-33: approvals the caller can decide, across every agent in the org.
export const Route = createFileRoute('/agents/approvals')({
  component: ApprovalsRoute,
});

function ApprovalsRoute() {
  return (
    <>
      <Head heading='Agents' />
      <AuthCheck>
        <AppLayout variant='full-bleed'>
          <FeatureGate feature={Feature.AGENTS}>
            <AgentsGate>
              <ApprovalsInbox />
            </AgentsGate>
          </FeatureGate>
        </AppLayout>
      </AuthCheck>
    </>
  );
}
